/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type QuartzJobState = 'ACTIVE' | 'PAUSED';

export const QuartzJobState = {

    ACTIVE: 'ACTIVE' as QuartzJobState,

    PAUSED: 'PAUSED' as QuartzJobState
};

